import React from 'react';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

import { reverse } from 'named-urls';

import Record from 'ui/Record/Record';

import { Button } from 'components/Button';
import { MainHeader } from 'components/MainHeader/MainHeader';

import { useNavBarHeight } from 'utils/hooks/navbar';
import { EntityModules } from 'core/constants';

import routes from 'core/routes';

import { useStore } from 'utils/hooks/store';

import { settingsObjectLabel } from 'containers/Dashboard/components/SideBar/utils';

import useFieldManagerParams from 'utils/hooks/useFieldManagerParams';

import FieldManagerTable from './components/FieldManagerTable/FieldManagerTable';

const FieldManager: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();

  const moduleName = useFieldManagerParams();

  const {
    session: { user },
    entityFields: { setActiveField },
  } = useStore();

  const onCreateNew = (): void => {
    setActiveField({
      uuid: '',
      key: '',
      // @ts-expect-error
      protectorType: '',
      name: '',
    });
  };

  const redirectToHelpCenter = (): void => {
    window.open(user?.helpCenterUrls.fieldManagerUrl, '_blank');
  };

  const link =
    moduleName === EntityModules.Events
      ? reverse(routes.dashboard.settings.objects.details.formBuilder.toString(), { moduleName })
      : reverse(routes.dashboard.settings.objects.details.fieldManager, { moduleName });

  return (
    <Record
      key={`field_manager_${moduleName}`}
      Header={
        <MainHeader
          title="Field Manager"
          breadcrumbs={[
            {
              label: 'Objects',
              link: '',
            },
            {
              label: settingsObjectLabel(moduleName as EntityModules, user),
              link,
            },
            {
              label: 'Field Manager',
              link,
            },
          ]}
          action={
            <>
              <Button
                onClick={redirectToHelpCenter}
                variant="text"
                size="large"
                startIcon={<HelpOutlineOutlinedIcon />}
                style={{ marginRight: '4px', width: '210px' }}
              >
                Field Manager Help
              </Button>
              <Button onClick={onCreateNew} variant="contained" size="large" sx={{ marginLeft: '4px' }}>
                New
              </Button>
            </>
          }
        />
      }
      Content={(onError) => <FieldManagerTable onError={onError} moduleName={moduleName} />}
      navBarHeight={navBarHeight}
    />
  );
};

export default FieldManager;
